// @flow
import * as React from 'react'

import styled from 'styled-components'
import { colors, SocialButtons } from '@components/shared'
import { AppleIcon } from '@components/shared/icons/AppleIcon'

export type PropsType = {
  isConnected: boolean,
  linkAccountRequestInProgress: boolean,
  isLoading: boolean
}

export type DispatchPropsType = {
  toggleAppleConnection: (isConnected: boolean) => void
}

export default function LinkApple (props: PropsType & DispatchPropsType): React.Node {
  return (
    <SocialButtons
      onClick={(): void => {
        props.toggleAppleConnection(props.isConnected)
      }}
      disabled={props.linkAccountRequestInProgress}
      isOutlineStyle={true}
    >
      <IconWrapper>
        <AppleIcon color={colors.white} size={18}/>
      </IconWrapper>
      <ButtonTextSpan>{props.isConnected ? 'Disconnect' : 'Connect'}{props.isLoading && 'ing'} Apple</ButtonTextSpan>
    </SocialButtons>
  )
}

const ButtonTextSpan = styled.span`
  margin-left: 10px;
`
const IconWrapper = styled.div`
  display: flex;
  margin-bottom: 2px;
`
